export default "__VITE_ASSET__68c44ce0__"